import React, { useEffect, useState } from "react";
import { fetchJobsByStatus } from "../../api/candidateApi";
import JobCard from "../../components/JobCard/JobCard";

function StatusJobList({ candidateId, status, employeeId, dateFilter }) {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    fetchJobsByStatus(candidateId, status, dateFilter)
      .then(res => setJobs(res.data.content))
      .catch(err => console.error(err));
  }, [candidateId, status]);

  return (
    <>
      <h3>{status} Jobs</h3>

      {jobs.length === 0 ? (
        <p>No jobs found.</p>
      ) : (
        jobs.map(job => <JobCard key={job.job.id} job={job.job} status={job.status} employeeId={employeeId}
          candidateId={candidateId} />)
      )}
    </>
  );
}

export default StatusJobList;
